import { render, staticRenderFns } from "./CompanySelectClients.vue?vue&type=template&id=2ef7ae52"
import script from "./CompanySelectClients.vue?vue&type=script&lang=js"
export * from "./CompanySelectClients.vue?vue&type=script&lang=js"
import style0 from "./CompanySelectClients.vue?vue&type=style&index=0&id=2ef7ae52&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports